import React from 'react';
import { TextButton, Typography } from 'seagull';
import { useGlobalContext } from "../../contexts";
import { LearnMore } from "./ClientFlowStructure/LearnMore";
import Logo from "../assets/logo.svg";
import styles from "./InfoFooter.module.scss";
import { useResponsive } from "../contexts";
import { useCobConfig } from "../clientOb/CobConfigContext";
export function InfoFooter(_ref) {
  var _vendorDetails$postal, _vendorDetails$postal2, _vendorDetails$postal3, _vendorDetails$postal4, _vendorDetails$postal5;
  let {
    showLearnMoreModal,
    'data-testid': testid
  } = _ref;
  const globalContext = useGlobalContext();
  const {
    isDesktop
  } = useResponsive();
  const {
    relationship
  } = useCobConfig();
  const vendorDetails = relationship.vendor;
  const vendorAddress = "".concat((_vendorDetails$postal = vendorDetails.postalAddress) === null || _vendorDetails$postal === void 0 ? void 0 : _vendorDetails$postal.addressOne, "\n\n").concat(((_vendorDetails$postal2 = vendorDetails.postalAddress) === null || _vendorDetails$postal2 === void 0 ? void 0 : _vendorDetails$postal2.addressTwo) || '', "\n\n").concat((_vendorDetails$postal3 = vendorDetails.postalAddress) === null || _vendorDetails$postal3 === void 0 ? void 0 : _vendorDetails$postal3.city, "\n\n").concat((_vendorDetails$postal4 = vendorDetails.postalAddress) === null || _vendorDetails$postal4 === void 0 ? void 0 : _vendorDetails$postal4.state, "\n\n").concat((_vendorDetails$postal5 = vendorDetails.postalAddress) === null || _vendorDetails$postal5 === void 0 ? void 0 : _vendorDetails$postal5.postalCode, " ");
  const showLearnMore = () => {
    globalContext.showModal({
      content(_ref2) {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(LearnMore, {
          isDesktop: isDesktop,
          onClose: dismissModal
        });
      },
      closeOnClickOutside: true,
      closeOnEscapeKey: true
    });
  };
  return /*#__PURE__*/React.createElement("footer", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    variant: "paragraph2",
    weight: "normal",
    className: styles.vendorName
  }, vendorDetails.name), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    variant: "paragraph2"
  }, vendorAddress), /*#__PURE__*/React.createElement("div", {
    className: styles.anchorRow
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    variant: "paragraph2",
    className: styles.poweredByAnchor
  }, "Powered by", /*#__PURE__*/React.createElement(Logo, null)), showLearnMoreModal && /*#__PURE__*/React.createElement(TextButton, {
    skin: "secondary",
    size: "small",
    onClick: showLearnMore,
    "data-testid": testid && testid + '-learn-more-btn'
  }, "Learn more")));
}